const reportWebVitals = (onPerfEntry?: (entry: PerformanceEntry) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((mod) => {
      if ('getCLS' in mod) (mod as Record<string, CallableFunction>).getCLS(onPerfEntry);
      if ('getFID' in mod) (mod as Record<string, CallableFunction>).getFID(onPerfEntry);
      if ('getFCP' in mod) (mod as Record<string, CallableFunction>).getFCP(onPerfEntry);
      if ('getLCP' in mod) (mod as Record<string, CallableFunction>).getLCP(onPerfEntry);
      if ('getTTFB' in mod) (mod as Record<string, CallableFunction>).getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
